<div class="radio-filter-cont">
  <app-box-filter
    [label]="label | transloco"
    [index]="index"
    [show]="isOpenBox"
    [individualFilter]="individualFilter"
    (toggleShow)="toggleCheckboxOptions()">
    <div class="list-container" [class.active]="isOpenBox">
      <div class="sorter-list">
        <ng-container *ngFor="let option of visibleOptions; index as i">
          <div class="radio">
            <app-ds-radio-button
              [checked]="isChecked(option.LowerBound)"
              [align]="radioButtonAlign"
              [title]="{ Label: option.Text }"
              [counter]="option.Ocurrence"
              (radioOnChecked)="selectOption(option)">
            </app-ds-radio-button>
          </div>
        </ng-container>
      </div>
      <div class="see-more-cont" *ngIf="seeMoreActive">
        <div class="see-more" (click)="toggleMoreFliters()">
          <app-ds-typography
            [fontFamily]="fontFamily.SemiBold"
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="(!seeMore ? 'SEE_MORE' : 'SEE_LESS') | transloco">
          </app-ds-typography>
        </div>
      </div>
    </div>
  </app-box-filter>
</div>
